// src/utils/scoring.js
//
// Single source of truth for all derived numbers across the app.
//
// The MATH lives in src/shared/scoringCore.js — shared with Cloud Functions
// through a generated copy, so the warehouse scores a person exactly as the
// dashboard does. This module adds the app-only layer (topic routing for the
// top/bottom-3 insights) and keeps the calculateScores(userProfile) contract
// every component already uses. Model documentation: docs/SCORING-MODEL.md.

import { METRIC_ROUTES } from '../data/guidedPathRoutes';
import { computeCore, emptyCore, SCORING_CONFIG } from '../shared/scoringCore';

export * from '../shared/scoringCore';

export const calculateScores = (userProfile) => {
    // 1. Safety check — nothing to score yet.
    if (!userProfile || !userProfile.latestStats) {
        return { ...emptyCore(), raw: {}, insights: { high: [], low: [] } };
    }

    const stats = userProfile.latestStats;
    const core = computeCore(stats);

    // 2. Top / bottom 3 insight metrics (app-only: needs the topic routes).
    // METRIC_ROUTES (src/data/guidedPathRoutes.js) is the canonical mapping of
    // metric -> label + destination topic, shared with the Guided Path.
    const validMetrics = [];
    SCORING_CONFIG.performance.metrics.forEach(key => {
        const val = stats[key];
        if (typeof val === 'number' && isFinite(val) && METRIC_ROUTES[key]) {
            validMetrics.push({ id: key, score: val, ...METRIC_ROUTES[key] });
        }
    });
    validMetrics.sort((a, b) => b.score - a.score);
    const highPerforming = validMetrics.slice(0, 3);
    // Lowest first; perfect scores never show as "low".
    const lowPerforming = validMetrics.slice(-3).reverse().filter(m => m.score < 100);

    return {
        ...core,
        raw: stats,
        insights: { high: highPerforming, low: lowPerforming }
    };
};
